/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/11/2022
 */

import { gql } from "urql";
import { ListResponse, SummaryNotification } from "../../interfaces/Global";

export const SummaryNotificationsQuery = gql`
    query SummaryNotifications($createdBy: String, $idIn: [ID!], $enabled: Boolean, $orderBy: String, $offset: Int, $limit: Int) {
        summaryNotifications(createdBy: $createdBy, idIn: $idIn, enabled: $enabled, orderBy: $orderBy, offset: $offset, limit: $limit) {
            total
            items {
                id
                createdBy
                creationDate
                modifiedBy
                modifiedDate
                vstamp
                properties
	            enabled
	            config
            }
        }
    }
`;

export interface SummaryNotificationsResponse {
	summaryNotifications: ListResponse<Partial<SummaryNotification>>
}

export interface SummaryNotificationsQueryVars {
	createdBy?: string
	enabled?: boolean
	orderBy?: string
	limit?: number
	offset?: number
}

export const SummaryNotificationQuery = gql`
    query SummaryNotification($id: ID!) {
        summaryNotification(id: $id) {
            id
            createdBy
            creationDate
            modifiedBy
            modifiedDate
            vstamp
            properties
	        enabled
	        config
        }
    }
`;

export interface SummaryNotificationResponse {
	summaryNotification: Partial<SummaryNotification>
}

export interface SummaryNotificationQueryVars {
	id: number
}